/**
 * One-shot suppression for the unsaved-work beforeunload prompt.
 * Call immediately before an intentional full-page leave (Stripe, billing, sign-out).
 * A later accidental tab close still warns once this window passes.
 */

let suppressedUntil = 0

export function suppressUnloadPrompt(ms = 120000) {
  suppressedUntil = Date.now() + ms
}

export function clearUnloadSuppression() {
  suppressedUntil = 0
}

export function isUnloadPromptSuppressed() {
  return Date.now() < suppressedUntil
}
